import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Trans, useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_HERO_DESCRIPTION,
  PRE_ACTIVATION_HERO_TITLE,
} from "../../../i18n/keysTranslations";
import OrganizationTypeSection from "./OrganizationTypeSection";

const HeroSection = ({
  control,
  readOnly = false,
  onOrganizationTypeChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography
        component="h1"
        sx={{
          fontSize: "28px",
          fontWeight: 900,
          color: "text.primary",
          letterSpacing: "-0.8px",
          lineHeight: 1.15,
          marginBottom: "10px",
        }}
      >
        <Trans
          i18nKey={PRE_ACTIVATION_HERO_TITLE}
          components={{
            br: <br />,
            em: (
              <Box
                component="em"
                sx={{
                  fontStyle: "normal",
                  color: "text.primary",
                }}
              />
            ),
          }}
        />
      </Typography>

      <Typography
        component="p"
        sx={{
          fontSize: "14px",
          color: "text.secondary",
          lineHeight: 1.6,
          maxWidth: "480px",
        }}
      >
        {t(PRE_ACTIVATION_HERO_DESCRIPTION)}
      </Typography>

      <Box sx={{ marginTop: "24px" }}>
        <OrganizationTypeSection
          control={control}
          readOnly={readOnly}
          onOrganizationTypeChange={onOrganizationTypeChange}
        />
      </Box>
    </>
  );
};

export default HeroSection;
